import BottomSheetNoPadding from '@/components/shared/bottom-sheet/bottom-sheet-no-padding.component';
import { CarDetailsType } from '@/types';
import { Dispatch, SetStateAction } from 'react';
import { CarDetailsHeader } from '../../../CarDetailsHeader/car-details-header';
import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import CarCTAs from '../../../CarCTAs';
import { TFunction } from 'i18next';
import { PriceBreakDownDetails } from './price-breakdown-details';
import { PriceBreakDownCarIncludes } from './price-breakdown-car-includes';
import { SylndrHelpSection } from '../../../SylndrHelpSection';
import { AVAILABLE_LANGUAGES } from '@/constants';

export const PriceBreakDownBottomSheet = ({
    openBottomSheet,
    setOpenBottomSheet,
    gradient,
    selectedCar,
    carType,
    t,
    lang,
}: {
    openBottomSheet: boolean;
    setOpenBottomSheet: Dispatch<SetStateAction<boolean>>;
    gradient: string;
    selectedCar: CarDetailsType;
    carType: CarTypesEnum;
    t: TFunction;
    lang: AVAILABLE_LANGUAGES;
}) => {
    return (
        <BottomSheetNoPadding
            open={openBottomSheet}
            setOpen={setOpenBottomSheet}
            className="!rounded-xl"
            drawerHeight="90%"
        >
            <div className="w-full min-h-full flex flex-col relative bg-white">
                <div className={`bg-gradient-to-b ${gradient}`}>
                    <div className="flex justify-center">
                        <div className="bg-gray-300 rounded-[100px] h-1 w-20 my-3 "></div>
                    </div>
                    <div className="mx-4 my-3">
                        <CarDetailsHeader
                            title={t('CarProfile.PriceBreakDown.title')}
                            selectedCar={selectedCar}
                            carType={carType}
                        />
                    </div>
                    {/* <CarTypeVideoEntryPoint
                        carType={carType}
                        IS_DESKTOP={false}
                    /> */}
                </div>
                <div className="px-4 mt-4 mb-2 flex flex-col gap-y-6">
                    <PriceBreakDownDetails
                        carData={selectedCar}
                        carType={carType}
                        t={t}
                    />
                    <PriceBreakDownCarIncludes carType={carType} t={t} />
                    <SylndrHelpSection
                        carType={carType}
                        lang={lang}
                        IS_DESKTOP={false}
                        clickable={false}
                    />
                </div>
            </div>
            <CarCTAs
                carInfo={selectedCar}
                t={t}
                IS_DESKTOP={false}
                showTip={false}
                financingSource="Car Price Breakdown"
            />
        </BottomSheetNoPadding>
    );
};
